import React, { createContext, useCallback, useState, useContext } from "react";
import { ICartoes } from "../services/cartao";
interface DadosContextData {
  codigo: string | "";
  loadingDados: boolean | false;
  cartaoCpf: string | "";
  tTelefone: string | "";
  celularToken: any;
  emailToken: any;
  tEmail: string | "";
  erro: string | "";
  passo: number | 0;
  carregarBeneficiario: boolean | false;
  qtCartoes: number | 0;
  dadosCartoes: ICartoes[];
  alteraPasso(passo: number): void;
  alteraErro(error: string | null): void;
  alteraQtCartoes(qt: number | 0): void;
  alteraDadosCartoes(dados: object | null): void;
  alteraCodigo(dados: string | null): void;
  alteraTokenTelefone(dados: string | null): void;
  alteraTokenEmail(dados: string | null): void;
  alteraCartaoCpf(dados: string | null): void;
  alteraLoadingBeneficiario(status:boolean): void;
  alteraCarregarBeneficiario(status:boolean): void;
  alteraCelularToken(dados: any): void;
  alteraEmailToken(dados: any): void;
}


const DadosContext = createContext<DadosContextData>({} as DadosContextData);

export const DadosProvider: React.FC = ({ children }) => {
  const [passo, setPasso] = useState(0);
  const [cartaoCpf, setCartao] = useState("");
  const [loadingDados, setLoadingDados] = useState(false);
  const [carregarBeneficiario, setCarregarBeneficiario] = useState(false);
  const [erro, setErro] = useState("");
  const [codigo, setCodigo] = useState("");
  const [tTelefone, setTTelefone] = useState("");
  const [celularToken, setCelularToken] = useState("");
  const [emailToken, setEmailToken] = useState("");
  const [tEmail, setTEmail] = useState("");
  const [qtCartoes, setQtCartoes] = useState(0);
  const [dadosCartoes, setDadosCartoes] = useState([]);

  const alteraCartaoCpf = useCallback((cartaoCpf) => {
    setCartao(cartaoCpf);
  }, []);

  const alteraPasso = useCallback((passo) => {
    setPasso(passo);
  }, []);

  const alteraErro = useCallback((error) => {
    setErro(error);
  }, []);

  const alteraQtCartoes = useCallback((qt) => {
    setQtCartoes(qt);
  }, []);

  const alteraDadosCartoes = useCallback((dados) => {
    setDadosCartoes(dados);
  }, []);

  const alteraCodigo = useCallback((codigo) => {
    setCodigo(codigo);
  }, []);

  const alteraTokenTelefone = useCallback((telefone) => {
    setTTelefone(telefone);
  }, []);

  const alteraTokenEmail = useCallback((email) => {
    setTEmail(email);
  }, []);

  const alteraLoadingBeneficiario = useCallback((status) => {
    setLoadingDados(status);
  }, []);

  const alteraCarregarBeneficiario = useCallback((status) => {
    setCarregarBeneficiario(status);
  }, []);

  const alteraCelularToken = useCallback((celular) => {
    setCelularToken(celular);
  }, []);

  const alteraEmailToken = useCallback((email) => {
    setEmailToken(email);
  }, []);
  
  return (
    <DadosContext.Provider
      value={{
        cartaoCpf,
        loadingDados,
        codigo,
        tTelefone,
        tEmail,
        passo,
        erro,
        qtCartoes,
        dadosCartoes,
        celularToken,
        emailToken,
        carregarBeneficiario,
        alteraPasso,
        alteraErro,
        alteraQtCartoes,
        alteraDadosCartoes,
        alteraCodigo,
        alteraTokenEmail,
        alteraTokenTelefone,
        alteraCartaoCpf,
        alteraLoadingBeneficiario,
        alteraCelularToken,
        alteraEmailToken,
        alteraCarregarBeneficiario
      }}
    >
      {children}
    </DadosContext.Provider>
  );
};

export function useCartao(): DadosContextData {
  const context = useContext(DadosContext);

  return context;
}
